import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {fromEvent, interval, Observable, Subject} from 'rxjs';
import {filter, takeUntil} from 'rxjs/operators';
import {UserService} from "./user.service";
import {environment} from "../../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #userService: UserService = inject(UserService);

  private readonly authWindowClosed$: Subject<void> = new Subject<void>();

  private authWindow!: Window;

  public user$: Observable<any> = this.#userService.user$;

  constructor() {
    this.#userService.requestUserProfile();
  }

  public login(): void {
    const params: Record<string, string | number> = {width: 450, height: 600, resizable: 'yes', scrollbars: 'yes'};
    const url = `${environment.apiAuthUrl}/authorization/steam`;
    this.initAuthWindowMessageListener();

    // @ts-ignore
    this.authWindow = window.open(url, 'auth', Object.keys(params).map(key => `${key}=${params[key]}`).join(','));
    this.authWindow?.focus();
    this.initAuthWindowStateListener();
  }

  public logout(): void {
    // this.#http.post(`${environment.apiUrl}/authorization/logout`, {}, {withCredentials: true})
    //   .subscribe(() => this.#userService.clearUserProfile());
    this.#userService.clearUserProfile()
  }

  private initAuthWindowMessageListener(): void {
    fromEvent<MessageEvent>(window, 'message')
      .pipe(takeUntil(this.authWindowClosed$))
      .subscribe((e: MessageEvent) => this.handleAuthResult(e));
  }

  private initAuthWindowStateListener(): void {
    interval(1000).pipe(
      takeUntil(this.authWindowClosed$),
      filter(() => this.authWindow.closed))
      .subscribe(() => this.authWindowClosed$.next());
  }

  private handleAuthResult(e: MessageEvent): void {
    const {success, provider, code} = e.data;
    if (provider) {
      if (success) {
        this.requestTokens(code);
        this.authWindow.close();
      }
    }
  }

  private requestTokens(code: string): void {
    this.#http.post<{
      accessToken: string
    }>(`${environment.apiUrl}/authorization/tokens`, {code}, {withCredentials: true})
      .subscribe(() => this.#userService.requestUserProfile());
  }

}
